/* Cleanflow FAQ page (cf-faq): instant search and sidebar topic tabs.
   Plain JS, no dependencies, scoped to each [data-cf-faq] block. */
(function () {
  'use strict';

  function normalise(value) {
    return (value || '').toString().toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function hasVisibleItem(el) {
    return !!el.querySelector('[data-cf-faq-item]:not([hidden])');
  }

  function initFaq(root) {
    if (root.dataset.cfFaqReady === 'true') return;
    root.dataset.cfFaqReady = 'true';

    var searchInput = root.querySelector('[data-cf-faq-search]');
    var emptyBox = root.querySelector('[data-cf-faq-empty]');
    var emptyTerm = root.querySelector('[data-cf-faq-empty-term]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cf-faq-item]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-cf-faq-group]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cf-faq-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cf-faq-panel]'));
    var hideWhileSearching = Array.prototype.slice.call(root.querySelectorAll('[data-cf-faq-hide-on-search]'));
    var hasTabs = tabs.length > 0;
    var activeTab = hasTabs ? tabs[0].getAttribute('data-cf-faq-tab') : null;

    items.forEach(function (item) {
      item.setAttribute('data-cf-faq-text', normalise(item.textContent));
    });

    /* Sidebar layout: show only the selected topic panel */
    function showTab(key) {
      activeTab = key;
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-pressed', tab.getAttribute('data-cf-faq-tab') === key ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-cf-faq-panel') !== key;
      });
    }

    function runSearch() {
      var term = normalise(searchInput ? searchInput.value : '');
      var searching = term.length > 0;
      var matches = 0;

      /* 1. Show or hide each question */
      items.forEach(function (item) {
        item.hidden = searching && item.getAttribute('data-cf-faq-text').indexOf(term) === -1;
      });

      if (hasTabs) {
        if (searching) {
          /* While searching, list matches from every topic (skip Top questions to avoid duplicates) */
          tabs.forEach(function (tab) { tab.setAttribute('aria-pressed', 'false'); });
          panels.forEach(function (panel) {
            var isTop = panel.getAttribute('data-cf-faq-panel') === 'top';
            panel.hidden = isTop || !hasVisibleItem(panel);
          });
        } else {
          showTab(activeTab);
        }
      } else {
        /* Quick Links layout: hide topic groups with no matching questions */
        groups.forEach(function (group) {
          group.hidden = searching && !hasVisibleItem(group);
        });
      }

      hideWhileSearching.forEach(function (el) { el.hidden = searching; });

      /* 2. Count visible matches for the "no results" message */
      items.forEach(function (item) {
        if (!item.hidden && !item.closest('[hidden]')) matches += 1;
      });

      if (emptyBox) {
        emptyBox.hidden = !searching || matches > 0;
        if (emptyTerm && searchInput) emptyTerm.textContent = searchInput.value;
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (searchInput) searchInput.value = '';
        showTab(tab.getAttribute('data-cf-faq-tab'));
        runSearch();
      });
    });

    if (searchInput) {
      var timer;
      searchInput.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(runSearch, 120);
      });
    }

    if (hasTabs) showTab(activeTab);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cf-faq]'), initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Re-run when the section is edited in the theme editor */
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
